import React, {useRef, useState, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Col, Row, Card, Form} from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import Navigation from "../components/Navigation";
import Heading from "../components/Heading";
import Footer from "../components/Footer";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import '../assets/css/react-draft.css';
import {
    addLettersTemplate,
    editLettersTemplate,
    getLettersTemplateById, getTemplateColumns, resetAddLettersTemplate,
    resetEditLettersTemplate
} from "../actions/LetterNoticesActions";
import Loader from "../components/Loader";
import AlertModal from "../components/AlertModal";
import {getCustomDynamicArray} from "../utils";
import {getAllLettersTemplatesList} from "../actions/ConfigActions";
import CdkAppEditor from "../components/CdkEditor/CdkAppEditor";

const EditTemplate = (props) => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const titleRef = useRef();
    const desciptionRef = useRef();
    const params = useParams();
    const location = useLocation();
    const { isCopyTemplate, lettersTemplateList } = location.state || {};

    const [fieldIsValid, setFieldIsValid] = useState({
        isTitleValid: true,
        isDescriptionValid: true,
        isTextValid: true,
        isCopyValid: true,
    });
    const [fieldData, setFieldData] = useState({
        dataDocument: null,
        dataTitle: null,
        dataDescription: null,
        dataText: null,
        dataCopy: null,
        dataStatus: null,
        isSignRequired: false,
    });
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    });
    const [alertDuplicate, setAlertDuplicate] = useState({
        display: false,
        type: "",
        message: ""
    });
    const [newCustomDynamicFields, setNewCustomDynamicFields] = useState([]);

    const getLettersTemplateDynamicColumns = useSelector(state => state.getTemplateColumn);
    const getLettersTemplateDetails = useSelector(state => state.getLettersTemplateById);
    const getAllLettersTemplate = useSelector(state => state.getAllLettersTemplateList);
    const {loadingLetter} = getLettersTemplateDetails;

    useEffect(() => {
        if (getLettersTemplateDynamicColumns.template_column?.customDynamicColumns) {
            setNewCustomDynamicFields(getLettersTemplateDynamicColumns.template_column.customDynamicColumns.map(item => item.columnName));
        }
    }, [getLettersTemplateDynamicColumns.template_column]);

    useEffect(() => {
        if (!getLettersTemplateDetails.letters_template_data <= 0) {
            setFieldData({
                ...fieldData,
                dataText: getLettersTemplateDetails.letters_template_data.documentText,
                dataCopy: getLettersTemplateDetails.letters_template_data.isHardcopyRequired,
                wysiwygRawData: getLettersTemplateDetails.letters_template_data.wysiwygRawData,
                dataStatus: getLettersTemplateDetails.letters_template_data.isActive,
                isSignRequired: getLettersTemplateDetails.letters_template_data.isSignRequired
            })
        }
    }, [getLettersTemplateDetails.letters_template_data]);

    const editLettersTemplateDetails = useSelector(state => state.editLettersTemplate)
    const {loadingEdit} = editLettersTemplateDetails
    const addLettersTemplateDetails = useSelector(state => state.addLettersTemplate)
    const {loadingAdd} = addLettersTemplateDetails

    useEffect(() => {
        if (editLettersTemplateDetails.letters_template === true || addLettersTemplateDetails.letters_template === true) {
            dispatch(resetEditLettersTemplate());
            setAlertModal({
                display: true,
                type: "success",
                message: isCopyTemplate ? "Template copied successfully" : "Template updated successfully"
            });
        }

        if (editLettersTemplateDetails.error || addLettersTemplateDetails.error) {
            dispatch(resetEditLettersTemplate());
            setAlertModal({
                display: true,
                type: "error",
                message: isCopyTemplate ? "Template couldn't be duplicated" : "Template couldn't be updated"
            });
        }
    }, [editLettersTemplateDetails, addLettersTemplateDetails]);

    const addTemplateDetails = useSelector(state => state.addLettersTemplate);
    const {loading} = addTemplateDetails;

    useEffect(() => {
        if (addTemplateDetails.letters_template === true) {
            dispatch(resetAddLettersTemplate())
            history('/letters-notices',{state:{success: "1"}})
        } if (addTemplateDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Couldn't add template"
            })
        }
    }, [addTemplateDetails]);

    useEffect(() => {
        if (addTemplateDetails.letters_template === true) {
            dispatch(resetAddLettersTemplate())
            history('/letters-notices',{state:{success: "1"}})
        } if (addTemplateDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Couldn't add template"
            })
        }
    }, [addTemplateDetails]);

    const getLettersTemplate = () => {
        dispatch(getLettersTemplateById(params.id));
        dispatch(getTemplateColumns(params.id));
        dispatch(getAllLettersTemplatesList(1000, 1));
    }

    useEffect(() => {
        getLettersTemplate()
    }, []);

    const checkCdkEditor = (data) => {
        if (data[0].length < 10) {
            setFieldIsValid({
                ...fieldIsValid,
                isTextValid: false,
            });
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isTextValid: true,
            });
            setFieldData({
                ...fieldData,
                dataText: data[0],
                wysiwygRawData: data[1],
            })
        }
    };

    const titleKeyPress = (event) => {
        event.preventDefault();

        if (!/^(?=.*[a-zA-Z\d\n].*)[a-zA-Z \d!@#$%&*.,-]{1,100}$/.test(titleRef.current.value)) {
            setFieldIsValid({
                ...fieldIsValid,
                isTitleValid: false,
            });
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isTitleValid: true,
            });
        }
    }

    const descriptionKeyPress = (event) => {
        event.preventDefault();

        if (!/.*?$/.test(desciptionRef.current.value)) {
            setFieldIsValid({
                ...fieldIsValid,
                isDescriptionValid: false,
            });
            setFieldIsValid({
                ...fieldIsValid,
                isDescriptionValid: true,
            });
        }
    }

    const selectCopy = (data) => {
        setFieldData({
            ...fieldData,
            dataCopy: data === 1
        })
    }

    const selectStatus = (data) => {
        setFieldData({
            ...fieldData,
            dataStatus: data === 1
        });
    }

    const openLink = () => {
        history('/letters-notices');
    }

    const onSubmit = (e) => {
        e.preventDefault();
        const filteredNewCustomDynamicFields = newCustomDynamicFields.length ? getCustomDynamicArray(newCustomDynamicFields, fieldData.dataText) : [];
        const {isDuplicatedName, nextId} = checkDuplicateAndNextId();

        if (isDuplicatedName) {
            setAlertDuplicate({
                display: true,
                type: "error",
                message: "The title is not unique."
            })

            return;
        }

        if (isCopyTemplate) {
            dispatch(addLettersTemplate(nextId, titleRef.current.value, desciptionRef.current.value, 1, fieldData.dataText, fieldData.dataCopy === 1, fieldData.isSignRequired, filteredNewCustomDynamicFields, fieldData.wysiwygRawData));
        } else {
            dispatch(editLettersTemplate(parseInt(params.id), titleRef.current.value, desciptionRef.current.value, fieldData.dataText, fieldData.dataCopy, fieldData.dataStatus, fieldData.isSignRequired, filteredNewCustomDynamicFields, true, fieldData.wysiwygRawData));
        }
    }

    const checkDuplicateAndNextId = () => {
        const allTemplateList = getAllLettersTemplate?.letter_template_list ?? [];

        if (!allTemplateList?.length) {
            return {isDuplicatedName: false};
        }

        if (titleRef.current.value?.trim() === getLettersTemplateDetails?.letters_template_data.title && !isCopyTemplate) {
            return {isDuplicatedName: false};
        }

        return allTemplateList.reduce((acc, letter) => {
            if (letter.title?.trim() === titleRef.current.value?.trim()) {
                acc.isDuplicatedName = true;
            }

            acc.nextId = Math.max(acc.nextId, letter.id);

            return acc;
        }, {nextId: 0, isDuplicatedName: false})
    }

    const onReset = () => {
        dispatch(getLettersTemplateById(params.id));
    }

    const closeAlert = () => {
        setAlertModal({ display: false });
        history('/letters-notices');
    }

    const closeDuplicateAlert = () => {
        setAlertDuplicate({ display: false });
    }

    const setIsSignatureRequired = () => {
        setFieldData({ ...fieldData, isSignRequired: !fieldData.isSignRequired });
    }

    const getContent = () => {
        const wysiwygRawData = getLettersTemplateDetails?.letters_template_data?.wysiwygRawData || '';
        const documentText = getLettersTemplateDetails?.letters_template_data?.documentText || '';

        if (typeof wysiwygRawData !== 'string') return '';

        if (wysiwygRawData?.trim()?.startsWith('{"blocks":')) {
            return documentText;
        }
        return wysiwygRawData;
    }

    const pageName = 'letters';

    return (
        <>
            <Row className="sidebar-background">
                {loading && <Loader/>}
                {loadingEdit && <Loader/>}
                {loadingAdd && <Loader/>}
                {loadingLetter && <Loader/>}
                {alertModal.display &&
                    <AlertModal heading={alertModal.message} type={alertModal.type}
                                result={closeAlert}/>}
                {alertDuplicate.display &&
                    <AlertModal heading={alertDuplicate.message} type={alertDuplicate.type}
                                result={closeDuplicateAlert}/>}
                <div className="float-left-child sidebar app-spacing">
                    <Sidebar pageDetails={pageName}/>
                </div>
                <div className="float-right-child app-background app-spacing">
                    <Navigation/>
                    <Heading group="create_new_template" title={isCopyTemplate ? 'Duplicate Template' : 'Update Template'} result={openLink}/>
                    <Row className="app-body-add-document background-1">
                        <Row className="background-1">
                            <Card className="card-body-default">
                                {getLettersTemplateDetails.letters_template_data && <form>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div className="document-form">
                                                <label htmlFor="document_title" id="documentTitleLabel"
                                                       className="form-label form-spacing">
                                                    Title<span className="asterics">*</span></label>
                                                <input ref={titleRef} onChange={titleKeyPress}
                                                       defaultValue={
                                                           isCopyTemplate
                                                               ? getLettersTemplateDetails.letters_template_data.title + " - copy"
                                                               : getLettersTemplateDetails.letters_template_data.title
                                                       }
                                                       type="text" autoComplete="off"
                                                       className={!fieldIsValid.isTitleValid ?
                                                           "input-error-form input-spacing" : "input-valid-form input-spacing"}
                                                       placeholder="Enter Title"
                                                       id="document_title"/>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div
                                                className={!fieldIsValid.isDescriptionValid ? "document-form-textarea-error"
                                                    : "document-form-textarea"}
                                            >
                                                <span className="text-label form-spacing">
                                                    Description<span className="asterics">*</span></span>
                                                <textarea ref={desciptionRef} onChange={descriptionKeyPress}
                                                          defaultValue={getLettersTemplateDetails.letters_template_data.descriptions}
                                                          className="textarea-input-error textarea-spacing"
                                                          placeholder="Enter Description" rows="4"
                                                          id="document_title"/>
                                            </div>
                                        </Col>

                                    </Row>
                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="">
                                        </Col>

                                        <div className="document-form padding-left-unset padding-right-unset">
                                            <CdkAppEditor
                                                result={checkCdkEditor}
                                                documentText={getContent()}
                                                dynamicValue={true}
                                                setNewCustomDynamicFields={setNewCustomDynamicFields}
                                                realOnly={false}
                                            />
                                        </div>
                                    </Row>
                                    <Row className="background-1">
                                        <Col lg={{span: 6, offset: 0}} md={{span: 6, offset: 0}}
                                             className="padding-left-unset padding-right-unset hardcopy-div">
                                            <div className="document-form">
                                                <div className="label-form-checkbox">
                                                    Hardcopy Required?
                                                </div>
                                                <div className="form-checkbox">
                                                    <Form.Check
                                                        className="float-left-child"
                                                        name="hardcopy"
                                                        label="Yes"
                                                        type="radio"
                                                        id="1"
                                                        checked={fieldData.dataCopy === true}
                                                        onChange={() => selectCopy(1)}
                                                    />
                                                    <Form.Check
                                                        className="float-right-child"
                                                        name="hardcopy"
                                                        label="No"
                                                        type="radio"
                                                        id="0"
                                                        checked={fieldData.dataCopy === false}
                                                        onChange={() => selectCopy(0)}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={{span: 6, offset: 0}} md={{span: 6, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div className="document-form">
                                                <div className="label-form-checkbox">
                                                    Letter Template Visibility
                                                </div>
                                                <div className="form-checkbox">
                                                    <Form.Check
                                                        className="float-left-child"
                                                        name="active"
                                                        label="Active"
                                                        type="radio"
                                                        id="1"
                                                        checked={fieldData.dataStatus === true}
                                                        onChange={() => selectStatus(1)}
                                                    />
                                                    <Form.Check
                                                        className="float-right-child"
                                                        name="active"
                                                        label="Inactive"
                                                        type="radio"
                                                        id="0"
                                                        checked={fieldData.dataStatus === false}
                                                        onChange={() => selectStatus (0)}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="background-1">
                                        <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                                             className="padding-left-unset padding-right-unset">
                                            <div className="document-form">
                                                <Form.Check
                                                    className="template-check"
                                                    name="new_template"
                                                    label="Require a signature for letters created from this template?"
                                                    type="checkbox"
                                                    id="1"
                                                    checked={fieldData.isSignRequired}
                                                    onChange={() => setIsSignatureRequired()}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    {(
                                            !fieldIsValid.isTitleValid
                                            || !fieldIsValid.isDescriptionValid
                                            || !fieldIsValid.isTextValid
                                            || !fieldIsValid.isCopyValid
                                        )
                                        &&
                                        <Row className="background-1 document-form submit-buttons">
                                            <Col lg={{span: 2}} className="padding-left-unset">
                                                <button disabled={true} className="button-solid button-inactive">
                                                    {isCopyTemplate ? 'Duplicate' : 'Update'}
                                                </button>
                                            </Col>
                                            <Col lg={{span: 2}} className="padding-right-unset">
                                                <button onClick={onReset}
                                                        className="button-solid button-transparent-active">
                                                    Reset
                                                </button>
                                            </Col>
                                        </Row>}
                                    {(
                                            fieldIsValid.isTitleValid
                                            && fieldIsValid.isDescriptionValid
                                            && fieldIsValid.isTextValid
                                            && fieldIsValid.isCopyValid
                                        )
                                        &&
                                        <Row className="background-1 document-form submit-buttons">
                                            <Col lg={{span: 2}} className="padding-left-unset">
                                                <button className="button-solid button-active"
                                                        onClick={onSubmit}
                                                >
                                                    {isCopyTemplate ? 'Duplicate' : 'Update'}
                                                </button>
                                            </Col>
                                            <Col lg={{span: 2}} className="padding-right-unset">
                                                <button className="button-solid button-transparent-active"
                                                        onClick={onReset}
                                                >
                                                    Reset
                                                </button>
                                            </Col>
                                        </Row>}
                                </form>}
                                <Footer/>
                            </Card>
                        </Row>
                    </Row>

                </div>
            </Row>
        </>
    );
}

export default EditTemplate;